import {useTranslation} from 'react-i18next';

export const useTranslationsOfBaselinesSelectionDialog = () => {
	return useTranslation('features/VehicleProjects/baselineChanges', {
		keyPrefix: 'BaselineSelectionDialog',
	});
};
